import { Registry } from '@react-registry'

export const tableCellDeserializer = (el) => {
    return {
        type: 'td',
        attrs: {}
    }
}

Registry.register(tableCellDeserializer, { id: 'table-cell', registry: 'v2.deserializer' })